import React from 'react'

function CopyIcon({ color = "currentColor", size = 24, ...rest }) {
    return (
        <svg {...rest} width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.39844 10.7999C8.39844 10.1634 8.65129 9.55293 9.10138 9.10285C9.55147 8.65276 10.1619 8.3999 10.7984 8.3999H17.9984C18.635 8.3999 19.2454 8.65276 19.6955 9.10285C20.1456 9.55293 20.3984 10.1634 20.3984 10.7999V17.9999C20.3984 18.6364 20.1456 19.2469 19.6955 19.697C19.2454 20.147 18.635 20.3999 17.9984 20.3999H10.7984C10.1619 20.3999 9.55147 20.147 9.10138 19.697C8.65129 19.2469 8.39844 18.6364 8.39844 17.9999V10.7999Z" fill={color} />
            <path d="M6.00156 3.6001C5.36504 3.6001 4.75459 3.85295 4.30451 4.30304C3.85442 4.75313 3.60156 5.36358 3.60156 6.0001V13.2001C3.60156 13.8366 3.85442 14.4471 4.30451 14.8972C4.75459 15.3472 5.36504 15.6001 6.00156 15.6001V6.0001H15.6016C15.6016 5.36358 15.3487 4.75313 14.8986 4.30304C14.4485 3.85295 13.8381 3.6001 13.2016 3.6001H6.00156Z" fill={color} />
        </svg>

    )
}

export default CopyIcon
